export type HEXColor = string;

export const COLORS = {
  WHITE: '#ffffff',
  BLACK: '#121212',
  BLUE_PRIMARY: '#2773CB',
  BLACK_PRIMARY: '#0C0C0C',
  DARKEST_GRAY: '#333532',
  DARK_GRAY: '#474747',
  GREY: '#A5A5A5',
  DARK_ONYX: '#383838',
  GRAY_SECONDARY: '#505050',
  ZAMBEZI_GRAY: '#5E5E5E',
  LIGHTEST_GRAY: '#FBFBFB',
  BRIGHT_GRAY: '#EAEAEA',
  MATTERHORN: '#575757',
  GRAY: '#F9F9F9',
  GRAY_94: '#F0F0F0',
  NORMAL_GRAY: '#656565',
  CHARCOAL: '#434343',
  LIGHT_GRAY: '#E6E6E6',
  LIGHT_GRAY_2: '#D5D5D5',
  GRAY_PRIMARY: '#888888',
  SOFT_GRAY: '#d9d9d9',
  IRON_GRAY: '#868686',
  MID_STEEL_GRAY: '#6E6E6E',
  GRAY_MEDIUM: '#959595',
  DIVIDER: '#D6D6D6',
  RED: '#D53A3A',
  DARK_RED: '#B61206',
  LIGHT_RED: '#f93e3e14',
  YELLOW: '#F6C16B',
  ORANGE: '#F37F41',
  YELLOW_PRIMARY: '#F8E437',
  PALE_YELLOW: '#F7C15F',
  BLUE: '#1FB1DA',
  DARK_BLUE: '#0C223A',
  GREEN: '#03BF52',
  GRAY_LIGHT: '#F2F2F2',
  DARK: '#525252',
  ANT_DEFAULT_ACCENT: '#1677ff',
  PURPLE: '#9C5DE3',
  PINK: '#FF61EA',
  DEEP_TEAL: '#06647E',
};

export const FONT_WEIGHTS = {
  BOLD: 700,
  SEMI_BOLD: 600,
  SEMI_NORMAL: 500,
  NORMAL: 400,
  SMALL: 300,
};

export const FONT_SIZES = {
  '10': '0.625rem',
  '12': '0.75rem',
  '14': '0.875rem',
  '15': '0.9375rem',
  '16': '1rem',
  '18': '1.125rem',
  '20': '1.25rem',
  '22': '1.375rem',
  '24': '1.5rem',
  '26': '1.6rem',
  '28': '1.75rem',
  '30': '1.875rem',
  '32': '2rem',
  '36': '2.25rem',
  '40': '2.5rem',
  '46': '2.9rem',
  '48': '3rem',
  '56': '3.5rem',
};

export const MOBILE_LAYOUT_MAX_WIDTH = 1024;

const SCREEN_SIZES = {
  MOBILE_S: '320px',
  MOBILE: '375px',
  MOBILE_L: '425px',
  MOBILE_XL: '480px',
  TABLET_S: '641px',
  TABLET: '834px',
  LAPTOP_S: '1025px',
  LAPTOP_M: '1366px',
  LAPTOP: '1440px',
  LAPTOP_L: '1640px',
  DESKTOP: '1920px',
  DESKTOP_L: '2560px',
};

export const SHADOWS = {
  LIGHTEST: `0px 3px 8px -1px rgba(50, 50, 71, 0.05), 0px 0px 1px 0px rgba(12, 26, 75, 0.24);`,
  LIGHTER: `0px 4px 20px -2px rgba(50, 50, 71, 0.08), 0px 0px 1px 0px rgba(12, 26, 75, 0.10);`,
  LIGHT: `0px 1px 2px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2)`,
  MEDIUM: `0px 0px 1px rgba(12, 26, 75, 0.24),
  0px 3px 8px -1px rgba(50, 50, 71, 0.05)`,
  BIG: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  SOLID_LIGHT: `0px 1px 3px rgba(0, 0, 0, 0.3);`,
  SOLID_MEDIUM: `0px 1px 8px 0px rgba(0, 0, 0, 0.25)`,
  MEDIUM_BLURRED: `0px 1px 8px 0px #00000040;`,
  ITEM_SHADOW: `0px 3px 8px -1px #3232470D`,
};

export const GRADIENTS = {
  BLUE: `linear-gradient(90deg, #0C223A 0%, #1D466B 100%);`,
};

export const DEVICES = {
  MOBILE_S: `(min-width: ${SCREEN_SIZES.MOBILE_S})`,
  MOBILE: `(min-width: ${SCREEN_SIZES.MOBILE})`,
  MOBILE_L: `(min-width: ${SCREEN_SIZES.MOBILE_L})`,
  MOBILE_XL: `(min-width: ${SCREEN_SIZES.MOBILE_XL})`,
  TABLET_S: `(min-width: ${SCREEN_SIZES.TABLET_S})`,
  TABLET: `(min-width: ${SCREEN_SIZES.TABLET})`,
  LAPTOP_S: `(min-width: ${SCREEN_SIZES.LAPTOP_S})`,
  LAPTOP_M: `(min-width: ${SCREEN_SIZES.LAPTOP_M})`,
  LAPTOP: `(min-width: ${SCREEN_SIZES.LAPTOP})`,
  LAPTOP_L: `(min-width: ${SCREEN_SIZES.LAPTOP_L})`,
  DESKTOP: `(min-width: ${SCREEN_SIZES.DESKTOP})`,
  DESKTOP_L: `(min-width: ${SCREEN_SIZES.DESKTOP_L})`,
};
